<template>
  <el-dialog
    title="上传包裹信息"
    :visible.sync="dialogVisible"
    width="700px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="120px">
      <el-form-item label="包裹运单号" prop="packageTransportDocument">
        <el-input v-model="form.packageTransportDocument" placeholder="请输入包裹运单号"></el-input>
      </el-form-item>
      <el-form-item label="包裹照片" prop="packageTransportList">
        <el-upload
          :action="uploadUrl"
          list-type="picture-card"
          :headers="headers"
          :on-success="handleAvatarSuccess"
          :on-preview="handlePictureCardPreview"
          :before-upload="beforeAvatarUpload"
          :file-list="fileList"
          :on-remove="handleRemove"
        >
          <i class="el-icon-plus"></i>
        </el-upload>
        <el-dialog :visible.sync="imgVisible" append-to-body>
          <img width="100%" :src="dialogImageUrl" alt />
        </el-dialog>
      </el-form-item>
    </el-form>
    <div slot="footer" class="footerBox">
      <div class="footerButton">
        <el-button type="primary" plain @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitHandle()" v-preventClick>提交</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { getToken } from "@/plugins/auth";
import { uploadPackage } from "@/api/request";
export default {
  data() {
    return {
      dialogVisible: false,
      dialogImageUrl: "",
      imgVisible: false,
      uploadUrl: process.env.VUE_APP_BASE_API + "/file/upload",
      headers: {
        Authorization: "Bearer " + getToken()
      },
      rules: {
        packageTransportDocument: [
          { required: true, trigger: "blur", message: "请输入包裹运单号" }
        ]
      },
      fileList: [],
      form: {
        orderId: "",
        packageTransportDocument: "",
        packageTransportList: []
      }
    };
  },
  methods: {
    init(info) {
      this.fileList = []
      this.form.packageTransportList = []
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs["form"].resetFields()
        this.form.orderId = info.orderId;
      });
    },
    handleAvatarSuccess(res, file) {
      const obj_1 = {
        name: res.data.name,
        url: res.data.url
      }
      const obj_2 = {
        name: res.data.name,
        url: process.env.VUE_APP_FILE_API + res.data.url
      }
      this.form.packageTransportList.push(obj_1)
      this.fileList.push(obj_2)
    },
    handleRemove(file, fileList) {
      this.fileList = this.fileList.filter(item => item.uid !== file.uid);
      this.form.packageTransportList = this.form.packageTransportList.filter(item => item.name !== file.name);
    },
    beforeAvatarUpload(file) {
      if (
        file.type != "image/jpeg" &&
        file.type != "image/png" &&
        file.type != "image/jpg"
      ) {
        this.$message.error("只能上传JPG/PNG格式!");
        return false;
      }
        return true;
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = process.env.VUE_APP_FILE_API + file.url;
      this.imgVisible = true;
    },
    submitHandle() {
      this.$refs.form.validate(valid => {
        if (valid) {
          uploadPackage(this.form).then(res => {
            this.dialogVisible = false
            this.$emit('refesh')
            this.$message.success("操作成功");
          });
        }
      });
    }
  }
};
</script>